//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'ValidationInvalidFeedback',
    data: () => {
        return {
            validationMessage: {
                email: 'O campo deve ser um endereço de e-mail válido.',
                phone: 'O campo não é um telefone válido.',
                minLength: 'O campo deve ter pelo menos {{min}} caracteres.',
                required: 'O campo é obrigatório.',
                sameAs: 'Os campos devem corresponder.',
                sameAsPassword: 'Os campos de senha devem corresponder.',
                sameAsEmail: 'Os campos de email devem corresponder.',
                isUnique: 'O campo já está sendo utilizado.',
                numeric: 'O campo recebe apenas números.',
            },
        };
    },
    props: {
        params: {
            type: Object,
        },
    },
    methods: {
        message: function (key, param) {
            param = param || key;

            let message = this.validationMessage[key]
                .replace(
                    /{{([\s\S]+?)}}/g,
                    param[Object.keys(param)[Object.keys(param).length - 1]]
                );

            return message;
        },
    },
}



// WEBPACK FOOTER //
// ./scripts/vue/components/common/ValidationInvalidFeedback.vue